"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DividerMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _constants = require("../../constants");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _marginMixin = require("../marginMixin");
var appearanceCSS = function appearanceCSS(props) {
  return (0, _styledToken.default)("Divider." + props.appearance + ".backgroundColor", function (backgroundColor) {
    return (0, _styledComponents.css)(["background-color:", ";"], backgroundColor);
  })(props);
};
var lengthCSS = function lengthCSS(props) {
  return (0, _styledToken.default)("Divider.lengths." + props.length, function (length) {
    var value = typeof length === 'number' ? length + "px" : length;
    return (0, _styledComponents.css)(["height:", ";width:", ";"], value, value);
  })(props);
};
var orientationCSS = function orientationCSS(props) {
  return (0, _styledToken.default)("Divider." + props.appearance + ".thickness", function (thickness) {
    return props.orientation === _constants.ORIENTATIONS.horizontal ? (0, _styledComponents.css)(["height:", "px;"], thickness) : (0, _styledComponents.css)(["width:", "px;"], thickness);
  })(props);
};

/** @class DividerMixin */
/** @method */
var DividerMixin = function DividerMixin(props) {
  return (0, _styledComponents.css)(["", " ", " ", " ", ""], appearanceCSS(props), (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('length', lengthCSS)(props), (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('orientation', orientationCSS)(props), (0, _marginMixin.marginMixin)(Object.assign({}, props)));
};
exports.DividerMixin = DividerMixin;